module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZkNTAwIiBkPSJNMCAwaDUxMi4wMDV2NTEySDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMDA1YmJiIiBkPSJNMCAwaDUxMi4wMDV2MjU2SDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ua.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ua.svg
// module chunks = 0